import { Layout, Space, Typography } from 'antd';
import { appVersion } from 'configs/variables';

export default function Footer({ mode = 'dark' }) {
  return (
    <Layout.Footer style={mode === 'light' ? { backgroundColor: '#fff', borderTop: 'unset' } : {}}>
      <div className="gx-layout-footer-content">
        <div className="space-align-block">
          <Space size={3} style={{ justifyContent: 'space-between', color: mode === 'light' ? '#000' : '#fff' }}>
            <span>© {`${new Date().getFullYear()}`} KK-POLICE All rights reserved.</span>

            <Typography.Text style={{ color: '#f5f5f5', opacity: 0.3 }}>{appVersion}</Typography.Text>
          </Space>
        </div>
      </div>
    </Layout.Footer>
  );
}
